import { render, staticRenderFns } from "./ErrorMessage.component.vue?vue&type=template&id=1ebe94cc&"
import script from "./ErrorMessage.component.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessage.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports